import React, {useState} from 'react';
import InfoSection from './info-section';
import moment from 'moment';
import { Button  } from 'react-bootstrap';
import { getIcon } from '../../../../components/crm/shared/field_inputs/shared/FormatHelpers';
import { useTranslation } from 'react-i18next';
import { COPIED_TO_CLIPBOARD, GENERAL_LECTURE_INFO_LECTURE_ADDRESS_LABEL, GENERAL_LECTURE_INFO_LECTURE_TIME, GENERAL_LECTURE_INFO_MEETING_LINK_LABEL, GENERAL_LECTURE_INFO_NO_SET_ADDRESS, GENERAL_LECTURE_INFO_NO_SET_MEETING_LINK, GENERAL_LECTURE_INFO_PARENT_COURSE, GENERAL_LECTURE_INFO_TEACHER_LABEL } from '../../../../i18n/keyConstants';

const getLectureDateDisplay = (startTime, endTime) => {
  moment.locale(localStorage.getItem('userLocale'));
  var formattedStartTime = moment.utc(startTime).local();
  var formattedEndTime = moment.utc(endTime).local();
  var totalLength = moment.utc(moment(formattedEndTime,"HH:mm:ss").diff(moment(formattedStartTime,"HH:mm:ss"))).local().format("H.mm");
  
  let dayOfWeek = formattedStartTime.format('dddd');
  dayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

  let month = formattedStartTime.format('MMMM');
  month = month.charAt(0).toUpperCase() + month.slice(1);

  return {
      dayOfWeek: dayOfWeek,
      date: formattedStartTime.format('YYYY-MM-DD'),
      dateDay: formattedStartTime.format('DD'),
      month: month,
      startTime: formattedStartTime.format('HH:mm'),
      endTime: formattedEndTime.format('HH:mm'),
      totalLength: totalLength,
  };
}

export default function GeneralLectureInformation({ lecture, lectureUser }) {
  const {
    teachers,
    startTime,
    endTime,
    meetingLink
  } = lecture;

  const formattedDates = getLectureDateDisplay(startTime, endTime);
  const { t } = useTranslation(['generalLectureInformation', 'shared']);

  function truncateUrl(url, maxLength) {
    if (url.length <= maxLength) {
      return url;
    }
    const truncatedUrl = url.substring(0, maxLength - 3) + '...';
    return truncatedUrl;
  }

  const [copySuccess, setCopySuccess] = useState(''); 
  const [currentIcon, setCurrentIcon] = useState('clipboard');

  let meetingLinkDisplay = null;
  let meetingLinkRights = false;

  const copyToClipboard = (text) => { navigator.clipboard.writeText(text); 
    setCopySuccess(t(COPIED_TO_CLIPBOARD, {ns: 'shared'})); 
    setCurrentIcon('clipboard-check');
    setTimeout(() => { setCopySuccess(''); setCurrentIcon('clipboard'); }, 3000);
  };  


  function meetingLinkDisplayLogic() {
    if (meetingLink && meetingLink.trim().length > 0) {
      meetingLinkDisplay = meetingLink;
    } else if (lecture.course.meetingLink && lecture.course.meetingLink.trim().length > 0) {
      meetingLinkDisplay = lecture.course.meetingLink;
    } 

    if ((lecture.course.courseFormat === 0 || lecture.course.courseFormat === 2) && ( lectureUser.editPermission || lectureUser.teacherPermission || (lectureUser.booking && [0, 3, 4, 5].includes(lectureUser.booking.status))) ){
      meetingLinkRights = true;
    }
  }

  meetingLinkDisplayLogic();

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      <InfoSection sectionLabel={t(GENERAL_LECTURE_INFO_TEACHER_LABEL)}>
        {teachers.map((teacher) => (
          <div key={teacher.id}>
            <a href={`/exlTeacherDetails/${teacher?.id}`}>{teacher.name}</a>
          </div>
        ))}
        {teachers.length < 1 && '-'}
      </InfoSection>
      
          <InfoSection sectionLabel={t(GENERAL_LECTURE_INFO_LECTURE_TIME)}>
        {formattedDates.dayOfWeek}, {formattedDates.dateDay} {formattedDates.month}
        <br/>
         {formattedDates.startTime} - {formattedDates.endTime} 
      </InfoSection>

      {(lecture.course.courseFormat === 1 || lecture.course.courseFormat === 2) && (
        <InfoSection sectionLabel={t(GENERAL_LECTURE_INFO_LECTURE_ADDRESS_LABEL)}>
          {lecture.course.location ? lecture.course.location: t(GENERAL_LECTURE_INFO_NO_SET_ADDRESS)}
        </InfoSection>
      )}

      <InfoSection sectionLabel={t(GENERAL_LECTURE_INFO_PARENT_COURSE)}>
        <a href={`/exlCourseDetails/${lecture.course.id}`}>{lecture.course.name}</a>
      </InfoSection>

       {(meetingLinkRights) && (
        <InfoSection sectionLabel={t(GENERAL_LECTURE_INFO_MEETING_LINK_LABEL)}>
         { meetingLinkDisplay ?
          <div>
            <a href={meetingLinkDisplay}>{truncateUrl(meetingLinkDisplay, 30)}</a>
            <Button onClick={() => copyToClipboard(meetingLinkDisplay)} style={{backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '5px 5px', border: 'none', color: 'black', outline: 'none', boxShadow: 'none',':focus': { outline: 'none', border: 'none' } }}>
              {getIcon(currentIcon)} 
            </Button>
            <span style={{position: 'absolute', right: '15', opacity: 0.6, paddingLeft: '5px'}}>{copySuccess}</span>
          </div>
           :
          <div>
            <span style={{ opacity: 0.6 }}> {t(GENERAL_LECTURE_INFO_NO_SET_MEETING_LINK)} </span>
          </div>
         }
       </InfoSection>
      )}

    </div>
  )
}
